import { BaseService } from "@/script/core/service/BaseService"
import { CallBack } from "@/script/core/service/DataService";

export class ServerService extends BaseService {
    public test<T>(callBack: CallBack<T>) {
        // api/device/server/test
        super.post("/api/service/file/test", {}).then(
            function (result) {
                console.error(result);
                callBack(result.data);
            },
            function (error: Error) {
                console.error(error);
            }
        );
    }
}
